(function(){
  var buy=document.querySelector('.a1-buy');if(!buy)return;
  var q=function(s){return buy.querySelector(':scope > '+s)};
  var cta=q('.a1-cta'),addons=q('.addons'),ship=q('.a1-ship'),risk=q('.a1-risk'),proof=q('.a1-proof'),facts=q('.a1-facts'),also=q('.a1-also'),lede=q('.lede'),more=q('.v4-more');
  if(!cta)return;
  // everything that is "nice to know" moves below the button, in a calm order
  var after=[ship,addons,risk,proof,facts,also,more].filter(Boolean),ref=cta;
  after.forEach(function(el){ref.insertAdjacentElement('afterend',el);ref=el});
  if(lede)lede.classList.add('v12-hide');
  // small lab-proof link in the fact row keeps the proof above the button
  var f=buy.querySelector('.v11-fact');if(f&&!f.querySelector('.v12-lab')){var a=document.createElement('a');a.className='v12-lab';a.href='#lab';a.innerHTML='<svg class="ic"><use href="#i-flask"/></svg>Eurofins lab report';f.appendChild(a)}
})();
